module.exports = __webpack_public_path__ + "static/media/img27.5d2f00eb.jpg";